<template>

  <div>
    <b-overlay :show="overlay">
      <b-card
          no-body
          class="mb-0"
      >
        <div class="m-2">
          <b-row>
            <!-- Per Page -->
            <b-col
                cols="12"
                md="6"
                class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
            >
              <label>Mostrar</label>
              <v-select
                  v-model="perPage"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="perPageOptions"
                  :clearable="false"
                  class="per-page-selector d-inline-block mx-50"
              />
              <label>entradas</label>
            </b-col>

            <b-col
                cols="12"
                md="6"
            >
              <div class="d-flex align-items-center justify-content-end">
                <b-input-group class="mr-1">
                  <b-form-input
                      v-model="searchInputValue"
                      class="d-inline-block"
                      placeholder="Pesquisar por código ou descrição..."
                      @keyup.enter="handleSearch"
                  />
                  <b-input-group-append>
                    <b-button :disabled="overlay" @click="clearSearch" variant="outline-danger">
                      <feather-icon icon="TrashIcon"/>
                    </b-button>
                    <b-button :disabled="overlay" @click="handleSearch" variant="outline-primary">
                      <feather-icon icon="SearchIcon"/>
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
  <!--              <div class="col-auto">-->
  <!--                <b-button-->
  <!--                    variant="primary"-->
  <!--                    v-b-modal.modal-add-unidade-medida-->
  <!--                    @click="resetFormData"-->
  <!--                >-->
  <!--                  <div class="d-flex" style="gap: 5px">-->
  <!--                    <iconfy icon="mdi:plus"/>-->
  <!--                    <span class="">Unidade Negocio</span>-->
  <!--                  </div>-->
  <!--                </b-button>-->
  <!--              </div>-->
              </div>
            </b-col>
          </b-row>

        </div>

        <b-table
            ref="refUnidadeNegocioListTable"
            class="position-relative"
            :items="fetchData"
            responsive
            :fields="tableColumns"
            primary-key="id"
            :sort-by.sync="sortBy"
            show-empty
            empty-text="Nenhum registro encontrado"
            :sort-desc.sync="isSortDirDesc"
        >
          <template #cell(item_situacao)="data">
            <b-badge
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                :variant="resolveItemStatusVariant(data.item.item_situacao)"
                class="text-primary"
            >
              {{ data.item.item_situacao }}
            </b-badge>
          </template>

          <!-- Column: Actions -->
          <template #cell(actions)="data">
            <div>
              <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="gradient-primary"
                  class="btn-icon mr-1"
                  v-b-modal.modal-add-unidade-medida
                  title="Visualizar"
                  @click="openEditModal(data.item)"
              >
                <feather-icon icon="EyeIcon"/>
              </b-button>

  <!--            <b-button-->
  <!--                variant="gradient-danger"-->
  <!--                class="btn-icon"-->
  <!--                @click="openModalDeleteCustomField(data.item)"-->
  <!--            >-->
  <!--              <feather-icon icon="TrashIcon"/>-->
  <!--            </b-button>-->
            </div>

          </template>

        </b-table>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col
                cols="12"
                sm="6"
                class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted">Mostrando {{ dataMeta.from }} até {{ dataMeta.to }} de {{
                  dataMeta.of
                }} entradas</span>
            </b-col>
            <!-- Pagination -->
            <b-col
                cols="12"
                sm="6"
                class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >
              <b-pagination
                  v-model="currentPage"
                  :total-rows="totalItem"
                  :per-page="perPage"
                  first-number
                  last-number
                  class="mb-0 mt-1 mt-sm-0"
                  prev-class="prev-item"
                  next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon
                      icon="ChevronLeftIcon"
                      size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon
                      icon="ChevronRightIcon"
                      size="18"
                  />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </b-card>
    </b-overlay>
    <ModalAdd
        idModal="modal-add-unidade-medida"
        titleModal="Visualizar Unidade Negocio"
        :labelBtnOk="dataItem.unidade_negocio_id !== null ? 'Fechar' : 'Adicionar'"
        v-model="dataItem"
        @ok="createOrUpdated($event)"
        @cancel="resetFormData()"
    />

    <modal-confirmation
        v-model="isDeleteModal"
        id-modal="modal-delete-item"
        title="Deletar Item"
        btn-cancel-label="Cancelar"
        btn-ok-label="Sim, deletar"
        @ok="handleRemover(deletedUnidadeNegocio.unidade_negocio_id)"
        @cancel="resetFormData()"
    >
      <template #message>
        <div>
          <p>Tem certeza que deseja deletar essa Item?</p>
        </div>
      </template>
    </modal-confirmation>

  </div>
</template>

<script>
import { onMounted, ref } from '@vue/composition-api';
import {
  BButton,
  BCard,
  BCardBody,
  BCardImg,
  BCardSubTitle,
  BCardText,
  BCardTitle,
  BCol,
  BRow,
  BListGroup,
  BListGroupItem,
  BTable,
  VBToggle,
  VBModal,
  BMedia,
  BLink,
  BAvatar,
  VBTooltip,
} from 'bootstrap-vue';
import { avatarText } from '@core/utils/filter';
import ModalConfirmation from '@/components/ModalConfirmation.vue';
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue';
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
import ModalAdd from './ModalAdd.vue';
import useList from './useList';

export default {
  components: {
    ModalAdd,
    BAvatar,
    BLink,
    BMedia,
    ModalConfirmation,
    BButton,
    BCard,
    BCardBody,
    BCardImg,
    BCardSubTitle,
    BCardText,
    BCardTitle,
    BCol,
    BRow,
    AppCollapse,
    AppCollapseItem,
    BListGroup,
    BListGroupItem,
    BTable,
  },
  directives: {
    'b-toggle': VBToggle,
    'b-modal': VBModal,
    'b-tooltip': VBTooltip,
  },
  data() {
    return {
      isDeleteModal: false,
      deletedUnidadeNegocio: {
        unidade_negocio_id: null,
        unidade_negocio_descricao: '',
        unidade_negocio_pedido_valor_minimo: '',
        unidade_negocio_pic_valor_minimo: '',
      },
      searchInputValue: '',
    };
  },
  methods: {
    handleRemover(id) {
      this.removerData(id);
      this.$toast({
        component: ToastificationContent,
        props: {
          title: 'Sucesso',
          text: 'Item deletado com sucesso',
          icon: 'CheckIcon',
          variant: 'success',
        },
      });
      this.isDeleteModal = false;
    },
    openModalDeleteCustomField(data) {
      this.deletedUnidadeNegocio = data;
      this.isDeleteModal = true;
    },
    openEditModal(data) {
      this.resetFormData();
      data.disabledInput = true;
      this.dataItem = data;
      this.$bvModal.show('modal-add-unidade-medida');
    },
    resetFormData() {
      this.dataItem = {
        unidade_negocio_id: null,
        unidade_negocio_descricao: '',
        unidade_negocio_pedido_valor_minimo: '',
        unidade_negocio_pic_valor_minimo: '',
      };
      this.isDeleteModal = false;
    },
    handleSearch() {
      this.searchQuery = this.searchInputValue;
    },
    clearSearch() {
      this.searchQuery = '';
      this.searchInputValue = '';
    },
  },
  setup() {
    const dataItem = ref({
      unidade_negocio_id: null,
      unidade_negocio_descricao: '',
      unidade_negocio_pedido_valor_minimo: '',
      unidade_negocio_pic_valor_minimo: '',
    });
    const currentTab = ref(0);
    const spanderAll = ref(false);
    const refCollapeseCamposPadrao = ref(null);
    const refCollapeseCamposPersonalizados = ref(null);

    const {
      perPage,
      currentPage,
      totalItem,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      tableColumns,
      refUnidadeNegocioListTable,
      fetchData,
      overlay,
      resolveTypeFieldText,
      resolveTypeFieldIcon,
      resolveItemStatusVariant,
      resolverDefaultValues,
      createOrUpdated,
      removerData,
    } = useList();

    return {
      // Filter
      avatarText,
      spanderAll,
      refCollapeseCamposPadrao,
      refCollapeseCamposPersonalizados,
      currentTab,
      dataItem,
      resolveTypeFieldText,
      resolveTypeFieldIcon,
      resolveItemStatusVariant,
      resolverDefaultValues,

      perPage,
      currentPage,
      totalItem,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      fetchData,
      overlay,
      tableColumns,
      refUnidadeNegocioListTable,
      createOrUpdated,
      removerData,
    };
  }
  ,
};
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}

.bg-header-collapse {
  background-color: #6c757d !important;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select';
</style>
